import React from 'react'
import { FormStartupOuterDiv } from "../style"

export const StartupAlreadyExistsModal = (): JSX.Element => {
  return (
    <FormStartupOuterDiv>
      <p>Deseja continuar com a conexão? Os dados que você preencheu (nome da startup, nome do representante e telefone) serão substituídos pelas informações existentes no sistema.</p>
    </FormStartupOuterDiv>
  )
}